import { SummaryTitle, DataLabel } from "components2/CommonUI";
import { FULL_DATE_TIME_FORMAT2 } from "constants/date";
import { APPT_TYPE, LANGUAGES, MODE_OF_CONTACT } from "constants/o2Appointment";
import moment from "moment";
import { useSelector } from "react-redux";

export const CustomerDetail = () => {
  const {
    nricFin,
    passport,
    language,
    emailUseUCD,
    emailFromUCD,
    email,
    mobileUseUCD,
    mobileNumberFromUCD,
    mobileNumber,
    haveCompanion,
    companionNricFin,
    companionPassport,
    modeOfContact,
  } = useSelector((state) => state.o2Appointment);

  // 4 columns if no companion, 3 columns if have companion
  const mdNumber = haveCompanion ? 3 : 4;

  return (
    <>
      <SummaryTitle>Customer details</SummaryTitle>
      <div className={"row px-3 sm-mt-24 md-mt-24 lg-mt-20 xl-mt-20 sm-mb-40 md-mb-40 lg-mb-44 xl-mb-44"}>
        <div className={`col-sm-12 col-md-${mdNumber} col-lg-3 sm-mb-48`}>
          <DataLabel label={"Customer ID"} data={nricFin || passport} />
        </div>
        <div className={`col-sm-12 col-md-${mdNumber} col-lg-3 sm-mb-48`}>
          <DataLabel label={"Language"} data={LANGUAGES.find(x=>x.id==language)?.language} />
        </div>
        <div className={`col-sm-12 col-md-${mdNumber} col-lg-3 ${haveCompanion ? "sm-mb-48" : ""}`}>
          {modeOfContact === MODE_OF_CONTACT.PHONE && (
            <DataLabel label={"Mobile number"} data={mobileUseUCD ? mobileNumberFromUCD : mobileNumber} />
          )}
          {modeOfContact === MODE_OF_CONTACT.EMAIL && (
            <DataLabel label={"Email address"} data={emailUseUCD ? emailFromUCD : email} />
          )}
        </div>
        {haveCompanion && (
          <div className={`col-sm-12 col-md-${mdNumber} col-lg-3`}>
            <DataLabel label={"Companion ID"} data={companionNricFin || companionPassport} />
          </div>
        )}
      </div>
    </>
  );
};

export const EnquiryDetail = () => {
  const {
    midDesc, sidDesc, haveCompanion
  } = useSelector((state) => state.o2Appointment);

  // Adjust according to Customer details
  // 4 columns if no companion, 3 columns if have companion
  const mdNumber = haveCompanion ? 3 : 4;


  return (
    <>
      <SummaryTitle>Enquiry details</SummaryTitle>
      <div className={"row px-3 sm-mt-24 md-mt-24 lg-mt-20 xl-mt-20 sm-mb-40 md-mb-40 lg-mb-44 xl-mb-44"}>
        <div className={`col-sm-12 col-md-${mdNumber} col-lg-3 sm-mb-48`}>
          <DataLabel label={"Category"} data={midDesc} />
        </div>
        <div className={`col-sm-12 col-md-${mdNumber} col-lg-3`}>
          <DataLabel label={"Topic"} data={sidDesc} />
        </div>
      </div>
    </>
  );
};

export const AppointmentDetail = () => {
  const {
    haveCompanion, apptType, locationDesc, 
    apptDateTime
  } = useSelector((state) => state.o2Appointment);

  // Adjust according to Customer details
  // 4 columns if no companion, 3 columns if have companion
  const mdNumber = haveCompanion ? 3 : 4;

  return (
    <>
      <SummaryTitle>Appointment details</SummaryTitle>
      <div className={"row px-3 sm-mt-24 md-mt-24 lg-mt-20 xl-mt-20 sm-mb-40 md-mb-40 lg-mb-44 xl-mb-44"}>
        <div className={`col-sm-12 col-md-${mdNumber} col-lg-3 sm-mb-48`}>
          <DataLabel label={"Appointment type"} data={apptType === APPT_TYPE.VISIT ? "Service centre" : "Phone call"} />
        </div>
        {apptType === APPT_TYPE.VISIT && (
          <div className={`col-sm-12 col-md-${mdNumber} col-lg-3 sm-mb-48`}>
            <DataLabel label={"Service centre"} data={locationDesc} />
          </div>
        )}
        <div className={`col-sm-12 col-md-${mdNumber} col-lg-3`}>
          <DataLabel label={"Date and time"} data={moment(apptDateTime).format(FULL_DATE_TIME_FORMAT2)} />
        </div>
      </div>
    </>
  );
};

export const TransactionDetail = () => {
  const {
    haveCompanion, bookingTxnId, transDateTime
  } = useSelector((state) => state.o2Appointment);

  // Adjust according to Customer details
  // 4 columns if no companion, 3 columns if have companion
  const mdNumber = haveCompanion ? 3 : 4;

  return (
    <>
      <SummaryTitle>Transaction details</SummaryTitle>
      <div className={"row px-3 sm-mt-24 md-mt-24 lg-mt-20 xl-mt-20 sm-mb-40 md-mb-40 lg-mb-44 xl-mb-44"}>
        <div className={`col-sm-12 col-md-${mdNumber} col-lg-3 sm-mb-48`}>
          <DataLabel label={"Service name"} data={"Book an appointment"} />
        </div>
        <div className={`col-sm-12 col-md-${mdNumber} col-lg-3 sm-mb-48`}>
          <DataLabel label={"Transaction number"} data={bookingTxnId} />
        </div>
          <div className={`col-sm-12 col-md-${mdNumber} col-lg-3`}>
          {/* <DataLabel label={"Transaction date"} data={"01 Dec 2022, 12:00pm"} /> */}
          <DataLabel label={"Transaction date"} data={moment(transDateTime).format(FULL_DATE_TIME_FORMAT2)} />
        </div>
      </div>
    </>
  );
};

